
<div :id="content.idHTML" class="TODO:" :class="jel_getClassObject(content)">
  <EditableArea
    v-if="mixinEnvironnement_inEditor"
    :content="content.notification"
    :parentTemplateId="metadata['mgnl:template']"
  />
  <Notification v-else-if="contentNotification" :content="contentNotification"></Notification>
</div>
